import { LandPlot, Building, Home, Hammer, Layers } from "lucide-react";
import { Reveal } from "./Reveal";

const segments = [
  { icon: LandPlot, title: "Commercial Land", body: "Strategically selected commercial land opportunities.", img: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&q=85", testid: "segment-commercial-land" },
  { icon: Building, title: "Commercial Buildings", body: "Commercial property development and ownership models.", img: "https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?crop=entropy&cs=srgb&fm=jpg&q=85", testid: "segment-commercial-buildings" },
  { icon: Home, title: "Residential Villas", body: "Premium villa development and property opportunities.", img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", testid: "segment-residential-villas" },
  { icon: Hammer, title: "Villa Development", body: "Land and villa development models based on location and market demand.", img: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", testid: "segment-villa-development" },
  { icon: Layers, title: "Property Development", body: "End-to-end property development models focused on ownership and long-term potential.", img: "https://images.pexels.com/photos/8470842/pexels-photo-8470842.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", testid: "segment-property-development" },
];

export const Segments = () => (
  <section id="segments" className="bg-stone py-20 md:py-28" data-testid="segments-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <Reveal>
        <p className="font-spec text-[11px] uppercase tracking-[0.25em] text-amberdark">What we deal in</p>
        <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-navy sm:text-4xl" data-testid="segments-headline">
          Five segments. <span className="text-amber">One discipline.</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="segments-grid">
        {segments.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.06}>
            <div
              data-testid={s.testid}
              className={`group relative h-80 overflow-hidden rounded-3xl ${i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}`}
            >
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/30 to-transparent" aria-hidden="true" />
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <span className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur-sm">
                  <s.icon size={17} />
                </span>
                <h3 className="font-display text-lg font-extrabold uppercase tracking-wide text-white">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/70">{s.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
